import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-detailspopups',
  templateUrl: './detailspopups.component.html',
  styleUrls: ['./detailspopups.component.css']
})
export class DetailspopupsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
